import React from 'react';
import { Skeleton } from 'primereact/skeleton';
import 'primereact/resources/themes/lara-light-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import '../../RegulatoryTab.styles.scss';
import './RegulatoryTabSkeleton.styles.scss';

const RegulatoryTabSkeleton: React.FC = () => {
  return (
    <div className="regulatory-tab-skeleton">
      {/* Country Matrix Section Skeleton */}
      <div className="country-matrix">
        <Skeleton
          width="30rem"
          height="1.5rem"
          style={{ marginBottom: '1.5rem', margin: '0 auto' }}
        />
        <div className="country-matrix-table-skeleton">
          <Skeleton width="100%" height="25rem" borderRadius="0.75rem" />
        </div>
        <Skeleton width="100%" height="3rem" style={{ marginTop: '1rem' }} />
      </div>
    </div>
  );
};

export default RegulatoryTabSkeleton;
